/**
 * @generated SignedSource<<edb98ad494d1a32cc64fb2ac318a9cce>>
 * @relayHash c0f50d607d3d17f6cda872c6bd54737e
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/572.0.0-2026-08-11T14:53:14.557Z/buildItemsGridDataQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type buildItemsGridDataQuery$variables = {
  abTestList?: ReadonlyArray<string | null> | null;
  consentedBuyerId?: string | null;
  editorsPicksCount: number;
  featuredItemsCount: number;
  guestId?: string | null;
  homepageId: string;
  isTrade: boolean;
  mostSavedCount: number;
  priceBookName: string;
  recentlyViewedItemIds: ReadonlyArray<string>;
  userCountryCode: string;
  userType: string;
};
export type buildItemsGridDataQuery$data = {
  readonly viewer: {
    readonly editorsPicks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly serviceId: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_item" | "hpSharedItemsGridTracking_item">;
        } | null;
      } | null> | null;
    } | null;
    readonly featuredItemsForYou: {
      readonly items: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_item" | "hpSharedItemsGridTracking_item">;
      } | null> | null;
      readonly metadata: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"useSponsoredItemsTracking_metadata">;
      } | null> | null;
    } | null;
    readonly homepage: {
      readonly modules: ReadonlyArray<{
        readonly items?: ReadonlyArray<{
          readonly imageUrl: string | null;
          readonly linkData: {
            readonly path: string | null;
          };
          readonly title: string | null;
        } | null> | null;
        readonly type?: string | null;
      } | null> | null;
    } | null;
    readonly mostSavedItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly serviceId: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_item" | "hpSharedItemsGridTracking_item">;
        } | null;
      } | null> | null;
    } | null;
    readonly personalizedCollections: ReadonlyArray<{
      readonly catalogType: string | null;
      readonly collectionId: string | null;
      readonly collectionName: string | null;
      readonly items: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridPersonalizedCollection_item" | "personalizedCollectionsTracking_item">;
      } | null> | null;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_viewer" | "SharedFavoritesProvider_viewer">;
  };
};
export type buildItemsGridDataQuery = {
  response: buildItemsGridDataQuery$data;
  variables: buildItemsGridDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": ([]/*:: as any*/),
  "kind": "LocalArgument",
  "name": "abTestList"
},
v1 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "consentedBuyerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "editorsPicksCount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "featuredItemsCount"
},
v4 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "guestId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "homepageId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mostSavedCount"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recentlyViewedItemIds"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userType"
},
v12 = [
  {
    "kind": "Variable",
    "name": "abTestList",
    "variableName": "abTestList"
  },
  {
    "kind": "Variable",
    "name": "rootId",
    "variableName": "homepageId"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "EditorialItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v13/*:: as any*/),
        (v14/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            (v15/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EditorialModule",
  "abstractKey": null
},
v17 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v18 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "editorsPicksCount"
  },
  (v17/*:: as any*/),
  {
    "kind": "Literal",
    "name": "uriRef",
    "value": "/collections/editors-picks/"
  },
  {
    "kind": "Variable",
    "name": "userCountryCode",
    "variableName": "userCountryCode"
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v23 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v24 = [
  (v19/*:: as any*/),
  {
    "kind": "InlineDataFragmentSpread",
    "name": "hpSharedItemsGridTracking_item",
    "selections": [
      (v19/*:: as any*/),
      (v20/*:: as any*/),
      (v21/*:: as any*/),
      (v22/*:: as any*/)
    ],
    "args": null,
    "argumentDefinitions": ([]/*:: as any*/)
  },
  {
    "args": [
      (v23/*:: as any*/),
      (v17/*:: as any*/)
    ],
    "kind": "FragmentSpread",
    "name": "HpSharedItemsGridContent_item"
  }
],
v25 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Item",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v24/*:: as any*/),
    "storageKey": null
  }
],
v26 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "mostSavedCount"
  },
  {
    "kind": "Literal",
    "name": "module",
    "value": "MOST_SAVED_MODULE"
  }
],
v27 = [
  {
    "kind": "Variable",
    "name": "guestId",
    "variableName": "guestId"
  },
  {
    "kind": "Variable",
    "name": "pageSize",
    "variableName": "featuredItemsCount"
  },
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "consentedBuyerId"
  }
],
v28 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "recentlyViewedItemIds"
  }
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collectionId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collectionName",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "catalogType",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contemporaryTrackingString",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v15/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v40 = [
  (v19/*:: as any*/),
  (v20/*:: as any*/),
  (v21/*:: as any*/),
  (v22/*:: as any*/),
  {
    "alias": "productPhotos",
    "args": [
      {
        "kind": "Literal",
        "name": "limit",
        "value": 1
      }
    ],
    "concreteType": "ItemPhoto",
    "kind": "LinkedField",
    "name": "photos",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "masterOrZoomPath",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "smallPath",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ItemPhotoVersion",
        "kind": "LinkedField",
        "name": "versions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "webPath",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v35/*:: as any*/)
    ],
    "storageKey": "photos(limit:1)"
  },
  (v33/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemMeasurement",
    "kind": "LinkedField",
    "name": "measurement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "addLabel",
            "value": true
          },
          {
            "kind": "Literal",
            "name": "fields",
            "value": [
              "height",
              "width",
              "depth",
              "diameter",
              "length"
            ]
          },
          {
            "kind": "Literal",
            "name": "separator",
            "value": " "
          }
        ],
        "concreteType": "ItemDisplayMeasurementType",
        "kind": "LinkedField",
        "name": "display",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unit",
            "storageKey": null
          },
          (v36/*:: as any*/)
        ],
        "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ItemSize",
        "kind": "LinkedField",
        "name": "size",
        "plural": false,
        "selections": [
          (v36/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isArt",
    "storageKey": null
  },
  (v14/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemClassification",
    "kind": "LinkedField",
    "name": "classification",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "creationDate",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemCreator",
    "kind": "LinkedField",
    "name": "creators",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Creator",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": [
          (v37/*:: as any*/),
          (v35/*:: as any*/)
        ],
        "storageKey": null
      },
      (v35/*:: as any*/)
    ],
    "storageKey": null
  },
  (v38/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isMultiSku",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRingItem",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "VariableAttribute",
    "kind": "LinkedField",
    "name": "variableAttributes",
    "plural": true,
    "selections": [
      (v19/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "VariableAttributeSortType",
        "kind": "LinkedField",
        "name": "variableAttributeData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SwatchSort",
            "kind": "LinkedField",
            "name": "swatchSort",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Swatch",
                "kind": "LinkedField",
                "name": "swatch",
                "plural": false,
                "selections": [
                  (v19/*:: as any*/),
                  (v37/*:: as any*/),
                  (v13/*:: as any*/),
                  (v35/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v35/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      (v23/*:: as any*/),
      {
        "kind": "Literal",
        "name": "page",
        "value": "searchAndBrowse"
      },
      (v17/*:: as any*/)
    ],
    "concreteType": "ItemDisplayPriceType",
    "kind": "LinkedField",
    "name": "displayPrice",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "kind": "LinkedField",
        "name": "convertedAmountList",
        "plural": true,
        "selections": (v39/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "kind": "LinkedField",
        "name": "originalConvertedAmountList",
        "plural": true,
        "selections": (v39/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quantityDisplay",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percentageOff",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "textType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amountType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showPriceLabel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showPriceVariability",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vertical",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ShipmentQuote",
    "kind": "LinkedField",
    "name": "shipmentQuotes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isComplimentary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCalculated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "kind": "LinkedField",
        "name": "totalAmount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ConvertedAmounts",
            "kind": "LinkedField",
            "name": "convertedAmounts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "USD",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ShipmentServiceMethod",
        "kind": "LinkedField",
        "name": "serviceMethod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Region",
            "kind": "LinkedField",
            "name": "region",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "regionName",
                "storageKey": null
              },
              (v35/*:: as any*/)
            ],
            "storageKey": null
          },
          (v35/*:: as any*/)
        ],
        "storageKey": null
      },
      (v35/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "QuickViewDisplayType",
    "kind": "LinkedField",
    "name": "quickViewDisplay",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QuickViewParagraph",
        "kind": "LinkedField",
        "name": "paragraphs",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          },
          {
            "alias": "mobileText",
            "args": [
              {
                "kind": "Literal",
                "name": "formatType",
                "value": "MOBILE"
              }
            ],
            "kind": "ScalarField",
            "name": "text",
            "storageKey": "text(formatType:\"MOBILE\")"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "QuickViewCreator",
        "kind": "LinkedField",
        "name": "creators",
        "plural": true,
        "selections": [
          (v37/*:: as any*/),
          (v38/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "QuickViewCategorySegments",
        "kind": "LinkedField",
        "name": "paragraphAttributeNames",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "period",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "origin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "style",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "periodPrefix",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v35/*:: as any*/)
],
v41 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Item",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v40/*:: as any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v11/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "buildItemsGridDataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HpSharedItemsGridContent_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SharedFavoritesProvider_viewer"
          },
          {
            "alias": null,
            "args": (v12/*:: as any*/),
            "concreteType": "Homepage",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v16/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "editorsPicks",
            "args": (v18/*:: as any*/),
            "concreteType": "ItemSearchItemsConnection",
            "kind": "LinkedField",
            "name": "itemSearchItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemSearchItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v25/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "mostSavedItems",
            "args": (v26/*:: as any*/),
            "concreteType": "ItemSearchTreandingConnection",
            "kind": "LinkedField",
            "name": "itemSearchTrending",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemSearchTreandingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v25/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "featuredItemsForYou",
            "args": (v27/*:: as any*/),
            "concreteType": "SponsoredItems",
            "kind": "LinkedField",
            "name": "personalizedSponsoredItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SponsoredItemsMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useSponsoredItemsTracking_metadata"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Item",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": (v24/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v28/*:: as any*/),
            "concreteType": "PersonalizedCollection",
            "kind": "LinkedField",
            "name": "personalizedCollections",
            "plural": true,
            "selections": [
              (v29/*:: as any*/),
              (v30/*:: as any*/),
              (v31/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Item",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  (v19/*:: as any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "HpSharedItemsGridPersonalizedCollection_item"
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "personalizedCollectionsTracking_item",
                    "selections": [
                      (v19/*:: as any*/),
                      (v14/*:: as any*/),
                      (v20/*:: as any*/),
                      (v21/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v19/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v32/*:: as any*/),
                      (v33/*:: as any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v10/*:: as any*/),
      (v8/*:: as any*/),
      (v6/*:: as any*/),
      (v4/*:: as any*/),
      (v9/*:: as any*/),
      (v5/*:: as any*/),
      (v11/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v7/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "buildItemsGridDataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v34/*:: as any*/),
          {
            "alias": "favoritesPageRedesignFF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "favoritesPageRedesign"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"favoritesPageRedesign\")"
          },
          {
            "alias": null,
            "args": (v12/*:: as any*/),
            "concreteType": "Homepage",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v34/*:: as any*/),
                  (v16/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "editorsPicks",
            "args": (v18/*:: as any*/),
            "concreteType": "ItemSearchItemsConnection",
            "kind": "LinkedField",
            "name": "itemSearchItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemSearchItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v41/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "mostSavedItems",
            "args": (v26/*:: as any*/),
            "concreteType": "ItemSearchTreandingConnection",
            "kind": "LinkedField",
            "name": "itemSearchTrending",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemSearchTreandingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v41/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "featuredItemsForYou",
            "args": (v27/*:: as any*/),
            "concreteType": "SponsoredItems",
            "kind": "LinkedField",
            "name": "personalizedSponsoredItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SponsoredItemsMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "itemId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "impressionTrackerLink",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clickTrackerLink",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Item",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": (v40/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v28/*:: as any*/),
            "concreteType": "PersonalizedCollection",
            "kind": "LinkedField",
            "name": "personalizedCollections",
            "plural": true,
            "selections": [
              (v29/*:: as any*/),
              (v30/*:: as any*/),
              (v31/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Item",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  (v19/*:: as any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "size",
                        "value": "medium"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "firstPhotoWebPath",
                    "storageKey": "firstPhotoWebPath(size:\"medium\")"
                  },
                  (v14/*:: as any*/),
                  (v33/*:: as any*/),
                  (v20/*:: as any*/),
                  (v21/*:: as any*/),
                  (v22/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      (v19/*:: as any*/),
                      (v35/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v32/*:: as any*/),
                  (v35/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v35/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/572.0.0-2026-08-11T14:53:14.557Z/buildItemsGridDataQuery",
    "metadata": {},
    "name": "buildItemsGridDataQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bed1ac4099ea9d1a9cf9c3102ff04078";

export default node;
